import { child, get, orderByChild, query, ref } from "firebase/database";
import { db, dbRef } from "../firebase/firebase";

export async function getJobPostList(jobId: string = "") {
  const snapshot = await get(
    query(ref(db, `/jobPostList/english/${jobId}`), orderByChild("jobPostDate"))
  );
  return snapshot.exists() ? snapshot : null;
}

export async function getJobPostDetails(jobId: string) {
  const snapshot = await get(child(dbRef, `/jobPostDetails/english/${jobId}`));
  return snapshot.exists() ? snapshot : null;
}